//portal related states
export const PORTAL_ROOT_STATE = `portal`;
export const DASHBOARD_STATE = `${PORTAL_ROOT_STATE}.dashboard`;
export const PORTAL_ADMIN_LOADER_STATE = `${PORTAL_ROOT_STATE}.load-admin`;
export const PORTAL_ADMIN_STATE = `${PORTAL_ROOT_STATE}.admin`;
